const firebaseConfig = {
  apiKey: "AIzaSyDnDsqsNVP2Ien5FkKXzH9TX7wZTlTPMnU",
  authDomain: "goldenkey-19edf.firebaseapp.com",
  projectId: "goldenkey-19edf",
  storageBucket: "goldenkey-19edf.firebasestorage.app",
  messagingSenderId: "1017222339912",
  appId: "1:1017222339912:web:407776c741e05fa25f677d"
};

export default firebaseConfig